import { z } from 'zod/v4';

/**
 * Validation for the Proposal-level discount form. The percentage is held as
 * the raw input string so out-of-range and empty entries reach react-hook-form
 * and gate submission, rather than being swallowed before validation. It is
 * coerced to a number on submit.
 */
export const proposalDiscountFormSchema = z.object({
  percentage: z
    .string()
    .trim()
    .min(1, 'Enter a discount percentage')
    .refine((value) => !Number.isNaN(Number(value)), 'Enter a valid percentage')
    .refine(
      (value) => Number(value) >= 0 && Number(value) <= 100,
      'Discount must be between 0% and 100%'
    )
    // Allow at most 3 decimal places, tolerant of floating-point error.
    .refine((value) => {
      const scaled = Number(value) * 1000;
      return Math.abs(scaled - Math.round(scaled)) <= 1e-6;
    }, 'Discount can have at most 3 decimal places'),
  description: z.string().optional(),
});

export type ProposalDiscountFormValues = z.infer<
  typeof proposalDiscountFormSchema
>;
